export const useDistanceText = (distance = 0) => {
  const isDistanceInMetres = distance <= 1000
  const distanceArray = [
    isDistanceInMetres ? Math.ceil(distance / 10) * 10 : (distance / 1000).toFixed(1),
    isDistanceInMetres ? 'm' : 'km'
  ]
  return distanceArray.join(' ');
}